import type { StickyItem, TextItem } from '@scribbleplot/shared';
import type { CSSProperties } from 'react';
import { color, font, TEXT_SIZES } from '../tokens';

export type ProseItem = StickyItem | TextItem;
export const TEXT_FONTS = { sans: font.sans, serif: 'Georgia, "Times New Roman", serif', mono: font.mono };

/** One rendering path for the canvas and live editor, including old documents. */
export function typography(item: ProseItem): CSSProperties {
  const style = item.textStyle ?? {};
  const base =
    item.type === 'sticky' ? { fontSize: 15, fontWeight: 500, letterSpacing: 'normal' } : TEXT_SIZES[item.size];
  return {
    ...base,
    fontFamily: TEXT_FONTS[style.fontFamily ?? 'sans'],
    fontSize: style.fontSize ?? base.fontSize,
    fontWeight: style.bold === undefined ? base.fontWeight : style.bold ? 700 : 400,
    fontStyle: style.italic ? 'italic' : 'normal',
    textDecoration: style.underline ? 'underline' : 'none',
    textAlign: style.align ?? 'left',
    color: style.color ?? (item.type === 'sticky' ? color.ink : color.text),
    lineHeight: item.type === 'sticky' ? 1.35 : 1.3,
  };
}
